import React from 'react'

const Contratos = () => {
   return (
      <>
         <div className="row mb-title">
            <div className="col s12 m12 l12 x12">
            <h5>
               <b>CONTRATOS</b>
            </h5>
            </div>
         </div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
            <h6>Volante de Pago Empleadas Domésticas </h6>
            <h6>Formulario AFIP F.102/TR</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
            <a target='_blank' className="btn btn-large waves-effect waves-light bg-latitud pulse" rel="noopener noreferrer"  href={`${process.env.REACT_APP_API_URL}/web/download/VolanteDePagoEmpleadasDomesticasFormAfip_F102TR.pdf`}>
               Descargar
               <i className="material-icons right">cloud_download</i>
            </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
            <h6>Volante de Pago Intereses de Cuotas</h6>
            <h6>Formulario AFIP F.801/C</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
            <a rel="noopener noreferrer" href={`${process.env.REACT_APP_API_URL}/web/download/VolantedePagoInteresesdeCuotasFormAfip_artf000093.pdf`} className="btn btn-large waves-effect waves-light bg-latitud pulse">
               Descargar
               <i className="material-icons right">cloud_download</i>
            </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
            <h6>Volante de Pago de Primera Cuota domésticas</h6>
            <h6>Formulario AFIP F.575/RT</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
            <a rel="noopener noreferrer" href={`${process.env.REACT_APP_API_URL}/web/download/VolantedePagodePrimeraCuotadomesticas_FormAfip_F575RT.pdf`} className="btn btn-large waves-effect waves-light bg-latitud pulse">
               Descargar
               <i className="material-icons right">cloud_download</i>
            </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
            <h6>Declaración Jurada sobre la condición de Persona</h6>
            <h6>Expuesta Políticamente</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
            <a rel="noopener noreferrer" href={`${process.env.REACT_APP_API_URL}/web/download/DeclaracionJuradasobrelacondiciondePersonaExpuestaPoliticamente.pdf`} className="btn  btn-large waves-effect waves-light bg-latitud pulse">
               Descargar
               <i className="material-icons right">cloud_download</i>
            </a>
            </div>
            <div id="seccionPrevencion"/>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
      </>
   );
}

export default Contratos